import DateRangePicker from "react-bootstrap-daterangepicker";
import React, { Component } from "react";
import moment from "moment";

const locale = {
  format: "YYYY-MM-DD HH:mm:ss",
  separator: " to ",
};

const ranges = {
  "Today": [
    moment.utc().startOf("day"),
    moment.utc().endOf("day")
  ],
  "Tomorrow": [
    moment.utc().add(1, "days").startOf("day"),
    moment.utc().add(1, "days").endOf("day")
  ],
  "24 Hours": [
    // these start and end times will never be used, as they are always set in onApply in the DateRangePicker
    moment.utc(),
    moment.utc().add(1, "days")
  ],
  "Next 5 Days": [
    moment.utc().startOf("day"),
    moment.utc().add(4, "days").startOf("day")
  ]
};

export default class CustomDatePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      start: props.value.start,
      end: props.value.end,
    }
  }

  handleRangeChange(range) {
    this.setState({
      start: range.start,
      end: range.end,
    })
    if (this.props.onChange) {
      this.props.onChange({
        start: range.start,
        end: range.end,
      });
    }
  }

  render() {
    let label =
      this.state.start.format(locale.format) +
      locale.separator +
      this.state.end.format(locale.format) +
      " UTC";

    return (
      <DateRangePicker
        initialSettings={{
          startDate: this.state.start,
          endDate: this.state.end,
          locale,
          containerClass: 'width-100',
          showDropdowns: true,
          alwaysShowCalendars: true,
          timePicker: true,
          drops: 'down',
          showCustomRangeLabel: false,
          ranges: ranges,
        }}
        onApply={(event, dateRangePicker) => {
          // If the chosen label is 24 hours, calculate this moment.
          let start = dateRangePicker.chosenLabel === "24 Hours"
            ? moment.utc()
            : dateRangePicker.startDate.utc(true);
          // If the chosen label is 24 hours, calculate 24 hours from this moment.
          let end = dateRangePicker.chosenLabel === "24 Hours"
            ? moment.utc().add(1, "days")
            : dateRangePicker.endDate.utc(true);
          this.setState({
            start: start,
            end: end,
          })
          if (this.props.onChange) {
            this.props.onChange({
              start: start,
              end: end,
            });
          }
        }}
      >
        <div
          className="daterangepicker-label"
          id="dateRange"
        >
          {label}
        </div>
      </DateRangePicker>
    );
  }
}
